<template>
  <div class="share-report-day boxbgcolor">
    <div class="right content-right list">
      <!-- 搜索区域 -->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label>车场:</label>
            <el-select 
              v-model="searchForm.parkId" 
              placeholder="请选择车场"
              clearable
            
              @change="watchParkChange"
            >
              <el-option
                v-for="item in parkList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="form-group">
            <label>车位:</label>
            <el-select 
              v-model="searchForm.spaceId" 
              placeholder="请选择车位"
              clearable
              class="form-control"
            >
              <el-option
                v-for="item in spaceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="form-group">
            <label>统计时间:</label>
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
           
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="handleSearch"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </el-button>
            </span>
            <span class="search_btn">
              <el-button
                @click="handleReset"
                type="button"
                class="btn btn-default"
              >
                导出
              </el-button>
            </span>
          </div>
        </form>
      </div>

      <!-- 数据列表 -->
      <div class="list-right">
        <el-table 
          :data="tableData" 
          border 
          stripe
          v-loading="loading"
          style="width: 100%"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          highlight-current-row
          show-summary
          :summary-method="getSummaries"
        >
        <el-table-column prop="date" label="时间" width="120" min-width="120" />
        <el-table-column prop="totalOrderAmount" label="订单总金额" width="140" min-width="140">
          <template slot-scope="scope">
            ¥{{ scope.row.totalOrderAmount || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="settledOrderAmount" label="已分账订单总金额" width="180" min-width="180">
          <template slot-scope="scope">
            ¥{{ scope.row.settledOrderAmount || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="platformShare" label="平台分账" width="140" min-width="140">
          <template slot-scope="scope">
            ¥{{ scope.row.platformShare || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="propertyShare" label="物业分账" width="140" min-width="140">
          <template slot-scope="scope">
            ¥{{ scope.row.propertyShare || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="personalShare" label="个人分账" width="140" min-width="140">
          <template slot-scope="scope">
            ¥{{ scope.row.personalShare || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="totalTimeoutAmount" label="超时总金额" width="140" min-width="140">
          <template slot-scope="scope">
            ¥{{ scope.row.totalTimeoutAmount || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="settledTimeoutAmount" label="已分账超时订单总金额" width="200" min-width="200">
          <template slot-scope="scope">
            ¥{{ scope.row.settledTimeoutAmount || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="timeoutPlatformShare" label="超时平台分账" width="160" min-width="160">
          <template slot-scope="scope">
            ¥{{ scope.row.timeoutPlatformShare || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="timeoutPropertyShare" label="超时物业分账" width="160" min-width="160">
          <template slot-scope="scope">
            ¥{{ scope.row.timeoutPropertyShare || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="timeoutPersonalShare" label="超时个人分账" width="160" min-width="160">
          <template slot-scope="scope">
            ¥{{ scope.row.timeoutPersonalShare || '0.00' }}
          </template>
        </el-table-column>
      </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { get, post } from '@/api/http'
import { 
  shareReportDayStatistics, 
  shareReportDayList,
  parkList,
  getSpaceList
} from '@/api/url'
import Page from "@/page/commons/page";
export default {
  name: 'ShareReportDay',
  data() {
    return {
      // 查询表单
      searchForm: {
        parkId: '',
        spaceId: '',
        dateRange: [] // 新增时间范围
      },
      
      // 车场列表
      parkList: [],
      
      // 车位列表
      spaceList: [],

      // 统计数据
      statistics: {
        totalOrderAmount: '0.00',
        settledOrderAmount: '0.00',
        platformShare: '0.00',
        propertyShare: '0.00',
        personalShare: '0.00',
        totalTimeoutAmount: '0.00',
        settledTimeoutAmount: '0.00',
        timeoutPlatformShare: '0.00',
        timeoutPropertyShare: '0.00',
        timeoutPersonalShare: '0.00'
      },

      // 表格数据
      tableData: [],
      loading: false,

      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  components: {
    Page,
  },
  mounted() {
    this.getParkList()
    this.getStatistics()
    this.getTableData()
  },
  
  methods: {
    // 表格样式配置
    tableHeaderStyle() {
      return {
        backgroundColor: '#f5f7fa',
        color: '#606266',
        fontWeight: 'bold',
        textAlign: 'center'
      }
    },
    
    tableCellStyle() {
      return {
        textAlign: 'center'
      }
    },

    // 获取车场列表
    async getParkList() {
      try {
        // 测试数据
        this.parkList = [
          { id: 1, name: '智慧停车场A' },
          { id: 2, name: '商业中心停车场B' },
          { id: 3, name: '住宅区停车场C' },
          { id: 4, name: '办公大楼停车场D' },
          { id: 5, name: '购物中心停车场E' }
        ]
        
        // 实际API调用（注释掉）
        // const response = await get(parkList(), {
        //   page: 1,
        //   pageSize: 1000
        // })
        // if (response.data && response.data.records) {
        //   this.parkList = response.data.records.map(item => ({
        //     id: item.id,
        //     name: item.parkingName
        //   }))
        // }
      } catch (error) {
        this.$message.error('获取车场列表失败')
        console.error('获取车场列表失败:', error)
      }
    },

    // 获取车位列表
    async getSpaceList() {
      try {
        if (!this.searchForm.parkId) {
          this.spaceList = []
          return
        }
        
        // 测试数据 - 根据车场ID返回不同的车位
        const spaceData = {
          1: [
            { id: 101, name: 'A区-001' },
            { id: 102, name: 'A区-002' },
            { id: 103, name: 'A区-003' },
            { id: 104, name: 'A区-004' },
            { id: 105, name: 'A区-005' }
          ],
          2: [
            { id: 201, name: 'B区-001' },
            { id: 202, name: 'B区-002' },
            { id: 203, name: 'B区-003' },
            { id: 204, name: 'B区-004' }
          ],
          3: [
            { id: 301, name: 'C区-001' },
            { id: 302, name: 'C区-002' },
            { id: 303, name: 'C区-003' },
            { id: 304, name: 'C区-004' },
            { id: 305, name: 'C区-005' },
            { id: 306, name: 'C区-006' }
          ],
          4: [
            { id: 401, name: 'D区-001' },
            { id: 402, name: 'D区-002' },
            { id: 403, name: 'D区-003' }
          ],
          5: [
            { id: 501, name: 'E区-001' },
            { id: 502, name: 'E区-002' },
            { id: 503, name: 'E区-003' },
            { id: 504, name: 'E区-004' },
            { id: 505, name: 'E区-005' }
          ]
        }
        
        this.spaceList = spaceData[this.searchForm.parkId] || []
        
        // 实际API调用（注释掉）
        // const response = await get(getSpaceList(), {
        //   parkingId: this.searchForm.parkId,
        //   page: 1,
        //   pageSize: 1000
        // })
        // 
        // if (response.data && response.data.records) {
        //   this.spaceList = response.data.records.map(item => ({
        //     id: item.id,
        //     name: item.spaceName || item.spaceNum
        //   }))
        // }
      } catch (error) {
        this.$message.error('获取车位列表失败')
        console.error('获取车位列表失败:', error)
      }
    },

    // 获取统计数据
    async getStatistics() {
      try {
        // 测试数据 - 根据查询条件返回不同的统计数据
        let statistics = {
          totalOrderAmount: '0.00',
          platformShare: '0.00',
          propertyShare: '0.00',
          personalShare: '0.00',
          totalTimeoutAmount: '0.00',
          timeoutPlatformShare: '0.00',
          timeoutPropertyShare: '0.00',
          timeoutPersonalShare: '0.00'
        }
        
        // 根据查询条件生成数据
        let multiplier = 1
        if (this.searchForm.parkId) {
          multiplier = this.searchForm.parkId * 0.5 + 0.5
        }
        
        // 时间范围影响
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          const startDate = new Date(this.searchForm.dateRange[0])
          const endDate = new Date(this.searchForm.dateRange[1])
          const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24))
          multiplier *= Math.min(daysDiff / 7, 2) // 最多2倍，最少0.14倍
        }
        
        const baseAmount = 1000 * multiplier
        
        statistics = {
          totalOrderAmount: (baseAmount + Math.random() * 5000).toFixed(2),
          settledOrderAmount: (baseAmount * 0.8 + Math.random() * 1000).toFixed(2),
          platformShare: (baseAmount * 0.2 + Math.random() * 1000).toFixed(2),
          propertyShare: (baseAmount * 0.5 + Math.random() * 2500).toFixed(2),
          personalShare: (baseAmount * 0.3 + Math.random() * 1500).toFixed(2),
          totalTimeoutAmount: (baseAmount * 0.1 + Math.random() * 500).toFixed(2),
          settledTimeoutAmount: (baseAmount * 0.07 + Math.random() * 100).toFixed(2),
          timeoutPlatformShare: (baseAmount * 0.02 + Math.random() * 100).toFixed(2),
          timeoutPropertyShare: (baseAmount * 0.05 + Math.random() * 250).toFixed(2),
          timeoutPersonalShare: (baseAmount * 0.03 + Math.random() * 150).toFixed(2)
        }
        
        Object.assign(this.statistics, statistics)
        
        // 实际API调用（注释掉）
        // const params = {}
        // if (this.searchForm.parkId) {
        //   params.parkId = this.searchForm.parkId
        // }
        // if (this.searchForm.spaceId) {
        //   params.spaceId = this.searchForm.spaceId
        // }
        // if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        //   params.startDate = this.searchForm.dateRange[0]
        //   params.endDate = this.searchForm.dateRange[1]
        // }
        // 
        // const response = await get(shareReportDayStatistics(), params)
        // 
        // if (response.data) {
        //   Object.assign(this.statistics, {
        //     totalOrderAmount: response.data.totalOrderAmount || '0.00',
        //     settledOrderAmount: response.data.settledOrderAmount || '0.00',
        //     platformShare: response.data.platformShare || '0.00',
        //     propertyShare: response.data.propertyShare || '0.00',
        //     personalShare: response.data.personalShare || '0.00',
        //     totalTimeoutAmount: response.data.totalTimeoutAmount || '0.00',
        //     settledTimeoutAmount: response.data.settledTimeoutAmount || '0.00',
        //     timeoutPlatformShare: response.data.timeoutPlatformShare || '0.00',
        //     timeoutPropertyShare: response.data.timeoutPropertyShare || '0.00',
        //     timeoutPersonalShare: response.data.timeoutPersonalShare || '0.00'
        //   })
        // }
      } catch (error) {
        this.$message.error('获取统计数据失败')
        console.error('获取统计数据失败:', error)
      }
    },

    // 获取表格数据
    async getTableData() {
      this.loading = true
      try {
        // 测试数据 - 生成模拟的表格数据
        const generateTestData = () => {
          const data = []
          const today = new Date()
          
          // 确定日期范围
          let startDate = new Date(today)
          let endDate = new Date(today)
          
          if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
            startDate = new Date(this.searchForm.dateRange[0])
            endDate = new Date(this.searchForm.dateRange[1])
          } else {
            // 默认显示最近30天，增加数据量来测试滚动
            startDate.setDate(today.getDate() - 30)
          }
          
          const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24))
          
          for (let i = 0; i <= daysDiff; i++) {
            const date = new Date(startDate)
            date.setDate(startDate.getDate() + i)
            
            const baseAmount = 1000 + Math.random() * 5000
            const timeoutAmount = baseAmount * 0.1 + Math.random() * 500
            const settledAmount = baseAmount * 0.8 + Math.random() * 1000
            const settledTimeoutAmount = timeoutAmount * 0.7 + Math.random() * 100
            
            data.push({
              date: date.toISOString().split('T')[0],
              totalOrderAmount: baseAmount.toFixed(2),
              platformShare: (baseAmount * 0.2).toFixed(2),
              propertyShare: (baseAmount * 0.5).toFixed(2),
              personalShare: (baseAmount * 0.3).toFixed(2),
              totalTimeoutAmount: timeoutAmount.toFixed(2),
              timeoutPlatformShare: (timeoutAmount * 0.2).toFixed(2),
              timeoutPropertyShare: (timeoutAmount * 0.5).toFixed(2),
              timeoutPersonalShare: (timeoutAmount * 0.3).toFixed(2),
              settledOrderAmount: settledAmount.toFixed(2),
              settledTimeoutAmount: settledTimeoutAmount.toFixed(2)
            })
          }
          
          return data
        }
        
        // 根据查询条件过滤数据
        let filteredData = generateTestData()
        
        if (this.searchForm.parkId) {
          // 根据车场ID调整数据
          const parkId = this.searchForm.parkId
          filteredData = filteredData.map(item => {
            const multiplier = parkId * 0.5 + 0.5
            return {
              ...item,
              totalOrderAmount: (parseFloat(item.totalOrderAmount) * multiplier).toFixed(2),
              platformShare: (parseFloat(item.platformShare) * multiplier).toFixed(2),
              propertyShare: (parseFloat(item.propertyShare) * multiplier).toFixed(2),
              personalShare: (parseFloat(item.personalShare) * multiplier).toFixed(2),
              totalTimeoutAmount: (parseFloat(item.totalTimeoutAmount) * multiplier).toFixed(2),
              timeoutPlatformShare: (parseFloat(item.timeoutPlatformShare) * multiplier).toFixed(2),
              timeoutPropertyShare: (parseFloat(item.timeoutPropertyShare) * multiplier).toFixed(2),
              timeoutPersonalShare: (parseFloat(item.timeoutPersonalShare) * multiplier).toFixed(2),
              settledOrderAmount: (parseFloat(item.settledOrderAmount) * multiplier).toFixed(2),
              settledTimeoutAmount: (parseFloat(item.settledTimeoutAmount) * multiplier).toFixed(2)
            }
          })
        }
        
        // 分页处理
        const startIndex = (this.pagination.currentPage - 1) * this.pagination.pageSize
        const endIndex = startIndex + this.pagination.pageSize
        
        this.tableData = filteredData.slice(startIndex, endIndex)
        this.pagination.total = filteredData.length
        
        // 实际API调用（注释掉）
        // const params = {
        //   page: this.pagination.currentPage,
        //   pageSize: this.pagination.pageSize
        // }
        // 
        // if (this.searchForm.parkId) {
        //   params.parkId = this.searchForm.parkId
        // }
        // if (this.searchForm.spaceId) {
        //   params.spaceId = this.searchForm.spaceId
        // }
        // if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        //   params.startDate = this.searchForm.dateRange[0]
        //   params.endDate = this.searchForm.dateRange[1]
        // }
        // 
        // const response = await get(shareReportDayList(), params)
        // 
        // if (response.data) {
        //   this.tableData = response.data.records || []
        //   this.pagination.total = response.data.total || 0
        // }
      } catch (error) {
        this.$message.error('获取列表数据失败')
        console.error('获取列表数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 计算汇总数据
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property === 'date') {
          sums[index] = '';
          return;
        }
        if (column.property === 'totalOrderAmount') {
          sums[index] = `¥${this.statistics.totalOrderAmount || '0.00'}`;
          return;
        }
        if (column.property === 'settledOrderAmount') {
          sums[index] = `¥${this.statistics.settledOrderAmount || '0.00'}`;
          return;
        }
        if (column.property === 'platformShare') {
          sums[index] = `¥${this.statistics.platformShare || '0.00'}`;
          return;
        }
        if (column.property === 'propertyShare') {
          sums[index] = `¥${this.statistics.propertyShare || '0.00'}`;
          return;
        }
        if (column.property === 'personalShare') {
          sums[index] = `¥${this.statistics.personalShare || '0.00'}`;
          return;
        }
        if (column.property === 'totalTimeoutAmount') {
          sums[index] = `¥${this.statistics.totalTimeoutAmount || '0.00'}`;
          return;
        }
        if (column.property === 'settledTimeoutAmount') {
          sums[index] = `¥${this.statistics.settledTimeoutAmount || '0.00'}`;
          return;
        }
        if (column.property === 'timeoutPlatformShare') {
          sums[index] = `¥${this.statistics.timeoutPlatformShare || '0.00'}`;
          return;
        }
        if (column.property === 'timeoutPropertyShare') {
          sums[index] = `¥${this.statistics.timeoutPropertyShare || '0.00'}`;
          return;
        }
        if (column.property === 'timeoutPersonalShare') {
          sums[index] = `¥${this.statistics.timeoutPersonalShare || '0.00'}`;
          return;
        }
        sums[index] = '';
      });
      return sums;
    },

    // 查询
    handleSearch() {
      this.pagination.currentPage = 1
      this.getStatistics()
      this.getTableData()
    },

    // 重置
    handleReset() {
      this.searchForm.parkId = ''
      this.searchForm.spaceId = ''
      this.searchForm.dateRange = [] // 重置时间范围
      this.pagination.currentPage = 1
      this.getStatistics()
      this.getTableData()
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.getTableData()
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getTableData()
    },

    // 监听车场选择变化
    watchParkChange() {
      this.searchForm.spaceId = ''
      if (this.searchForm.parkId) {
        this.getSpaceList()
      } else {
        this.spaceList = []
      }
    }
  }
}
</script>

<style scoped>
.content-right {
  width: 100%;
}

.list {
  padding: 0 16px 40px;
  height: calc(100vh - 125px);
}

/* 搜索区域样式 - 项目标准版本 */
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  padding: 10px;
  margin-bottom: 0;
}

.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 80px;
  vertical-align: middle;
}

.form-group {
  margin-bottom: 2px;
  margin-right: 10px;
}

.form-group label {
  margin-right: 10px;
  font-weight: 100;
  color: #222;
}

.form-control {
  border-radius: 4px;
  transition: border-color 0.2s ease;
  border: none !important;
  box-shadow: none !important;
}

/* 修复form-group的垂直对齐 */
.form-group {
  margin-bottom: 2px;
  margin-right: 10px;
  display: flex !important;
  align-items: center !important;
  vertical-align: middle !important;
}

.form-group label {
  margin-right: 10px;
  font-weight: 100;
  color: #222;
  line-height: 1 !important;
  margin-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.form-control:focus {
  border-color: #409eff;
}

.others {
  display: -webkit-flex !important;
  display: flex !important;
  justify-content: center;
}

.search_btn {
  display: inline-block;
  margin-right: 5px;
}

/* 按钮样式 - 项目标准版本 */
.btn {
  border-radius: 0px;
  border: 1px solid #409eff;
  color: #409eff;
  padding: 6px 20px;
  transition: all 0.2s ease;
}

.btn-primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}

.btn-primary:active {
  background-color: #3a8ee6 !important;
  border-color: #3a8ee6 !important;
}

.btn-default {
  background: none;
  color: #409eff;
}

.btn-default:hover {
  background-color: #409eff;
  color: #fff;
}

/* 表格区域样式 - 项目标准版本 */
.list-right {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  height: calc(100vh - 250px);
  padding-bottom: 20px;
}

/* 表格美化样式 - 与项目统一 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
}

/* 表头样式优化 - 简化版本 */
.el-table th {
  background: #f8f9fa !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
  border: none !important;
  border-bottom: 1px solid #e4e7ed !important;
  transition: background-color 0.2s ease;
}

.el-table th:hover {
  background: #e9ecef !important;
}

/* 表格行悬停效果 - 简化版本 */
.el-table tbody tr {
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.el-table tbody tr:hover > td {
  background: #f8f9fa !important;
}

/* 斑马纹效果 */
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #fafbfc;
}

/* 表格边框优化 */
.el-table--border th,
.el-table--border td {
  border-right: 1px solid #ebeef5;
}

/* 当前行高亮 */
.el-table__current-row > td {
  background-color: #e3f2fd !important;
}

/* 统计行样式 */
.el-table__footer-wrapper .el-table__footer {
  background-color: #f8f9fa !important;
}

.el-table__footer-wrapper .el-table__footer td {
  background-color: #f8f9fa !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
  border-top: 2px solid #409eff !important;
  text-align: center !important;
}

.el-table__footer-wrapper .el-table__footer td:first-child {
  color: #409eff !important;
  font-weight: 700 !important;
  text-align: center !important;
}

/* 强制统计行居中 - 使用更高优先级 */
.el-table .el-table__footer td {
  text-align: center !important;
}

.el-table .el-table__footer td:first-child {
  text-align: center !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .form-group {
    margin-right: 8px;
  }
}

@media (max-width: 992px) {
  .form-group {
    margin-right: 6px;
  }
}

@media (max-width: 768px) {
  .searchbox {
    padding: 8px;
  }

  .form-inline {
    height: auto;
    flex-direction: column;
    align-items: stretch;
  }

  .form-group {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .list-right {
    margin: 10px;
  }
}

@media (max-width: 480px) {
  .searchbox {
    padding: 6px;
  }

  .form-group {
    margin-bottom: 8px;
  }
}
</style>
<style>
.share-report-day .el-table .el-table__cell {
  text-align: center!important;
}

</style>
